function shortenString(input: string, length: number): string {
  if (input.length <= length) {
    return input;
  }

  let maxLength = length - 3;

  if (maxLength <= 0) {
    return '';
  }

  return input.slice(0, maxLength + 1) + '...';
}

export default shortenString;
